import type { FC, ReactNode } from 'react';
import { memo, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

type PortalProps = {
  id: string;
  children: ReactNode | null;
};
const Portal: FC<PortalProps> = ({ id, children }) => {
  const el = useRef(document.getElementById(id) || document.createElement('div'));
  const [dynamic] = useState(!el.current.parentElement);
  useEffect(() => {
    const memoisedEl: HTMLElement = el.current;
    if (dynamic) {
      el.current.id = id;
      document.body.appendChild(el.current);
    }

    return () => {
      if (dynamic && memoisedEl.parentElement) {
        memoisedEl.parentElement.removeChild(memoisedEl);
      }
    };
  }, [id, dynamic]);

  return createPortal(children, el.current);
};

export default memo(Portal);
